import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "w-full max-w-xs overflow-y-auto" }
const _hoisted_2 = {
  key: 0,
  class: "mb-6 pb-2 border-b border-gray-400"
}
const _hoisted_3 = { class: "mt-4 overflow-hidden" }
const _hoisted_4 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_5 = { class: "mt-2" }
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(_ctx.title), 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (cat) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_3, [
        (_ctx.title)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_4, _toDisplayString(cat.title), 1))
          : _createCommentVNode("", true),
        _createElementVNode("ol", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getLibraryComponents(cat), (comp) => {
            return (_openBlock(), _createElementBlock("li", _hoisted_5, [
              _createElementVNode("a", {
                class: "font-semibold text-blue-700 hover:underline hover:text-indigo-800",
                href: "#",
                onClick: _withModifiers(($event: any) => (_ctx.handleComponentSelected(comp)), ["prevent"])
              }, _toDisplayString(comp.title), 9, _hoisted_6)
            ]))
          }), 256))
        ])
      ]))
    }), 256))
  ]))
}